// React Dependencies
import React, { useEffect, useState } from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Paper, Table, TableBody,
  TableCell, TableContainer, TableHead, TablePagination, TableRow,
  TextField, MenuItem } from '@material-ui/core';

// Internal Dependencies
import { IsEmpty } from '../../../../common/checks';
import { GiftType, RedeemStatus } from '../../../../common/constants';
import MText from '../../../../components/Common/MText';
import { dateStrToFormat } from '../../../../common/convert';

const ShopperGiftFilter = {
  Id:                'id',
  Status:            'status',
  RedeemOutletId:    'redeemOutletId',
  ClaimDate:         'claimDate',
  ShopperRedeemDate: 'shopperRedeemDate',
  IssueDate:         'issueDate',
  IssuedBy:          'issuedBy',
};

const filterInputStyle = { fontSize: 13 };

function EnhancedTableHead(props) {
  const { onSelectAllClick, numSelected, rowCount, claims } = props;
  const [filter, setFilter] = useState();
  const [status, setStatus] = useState('');

  const onFilterChange = (e, field) => {
    e.preventDefault();
    const { value } = e.target;

    const filters = { ...filter };
    if (IsEmpty(value) && field in filter) {
      delete filters[field];
    }

    if (!IsEmpty(value)) {
      filters[field] = field === 'redeemOutletId' ? parseInt(value, 10) : value;
    }

    setFilter(filters);
    props.filterShopperGift(filters);
  };

  return (
    <TableHead>
      <TableRow style={{ color: '#000' }}>
        {/* <TableCell>
          <MText text="Select" />
        </TableCell> */}
        <TableCell>
          <MText text="Status" />
        </TableCell>
        <TableCell>
          <MText text="Participating Outlet ID" />
        </TableCell>
        {/* <TableCell>
          <MText text="Claim date" />
        </TableCell> */}
        <TableCell>
          <MText text="Issuance Datetime" />
        </TableCell>
        <TableCell>
          <MText text="Redemption Datetime" />
        </TableCell>
        {/* <TableCell>
          <MText text="Issued By" />
        </TableCell> */}
        <TableCell>
          <MText text={`Cust. ${props.type === GiftType.Voucher ? 'Voucher' : 'Coupon'} ID`} />
        </TableCell>
      </TableRow>
      <TableRow>
        {/* <TableCell padding="checkbox">
          {
            claims && (
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAllClick}
                inputProps={{ 'aria-label': 'select all desserts' }}
              />
            )
          }
        </TableCell> */}

        <TableCell>
          <TextField
            id="standard-select-currency"
            select
            InputProps={{
              style: filterInputStyle,
            }}
            value={status}
            onChange={(e) => {
              setStatus(e.target.value);
              onFilterChange(e, ShopperGiftFilter.Status);
            }}
          >
            <MenuItem value=""><MText text="All" /></MenuItem>
            <MenuItem value={RedeemStatus.Unredeemed}><MText text={RedeemStatus.Unredeemed} /></MenuItem>
            <MenuItem value={RedeemStatus.Redeemed}><MText text={RedeemStatus.Redeemed} /></MenuItem>
            {/* <MenuItem value={RedeemStatus.Claimed}><MText text={RedeemStatus.Claimed} /></MenuItem> */}
          </TextField>
        </TableCell>

        <TableCell>
          <TextField
            InputProps={{
              style: filterInputStyle,
            }}
            id="input-with-icon-textfield"
            onChange={(e) => onFilterChange(e, ShopperGiftFilter.RedeemOutletId)}
          />
        </TableCell>
        {/* <TableCell>
          <TextField
            id="input-with-icon-textfield"
            InputProps={{
              style: filterInputStyle,
            }}
            type="date"
            onChange={(e) => onFilterChange(e, ShopperGiftFilter.ClaimDate)}
          />
        </TableCell> */}
        <TableCell>
          <TextField
            id="input-with-icon-textfield"
            InputProps={{
              style: filterInputStyle,
            }}
            type="date"
            onChange={(e) => onFilterChange(e, ShopperGiftFilter.IssueDate)}
          />
        </TableCell>
        <TableCell>
          <TextField
            id="input-with-icon-textfield"
            InputProps={{
              style: filterInputStyle,
            }}
            type="date"
            onChange={(e) => onFilterChange(e, ShopperGiftFilter.ShopperRedeemDate)}
          />
        </TableCell>
        {/* <TableCell>
          <TextField
            id="input-with-icon-textfield"
            InputProps={{
              style: filterInputStyle,
            }}
            onChange={(e) => onFilterChange(e, ShopperGiftFilter.IssuedBy)}
          />
        </TableCell> */}
        <TableCell>
          <TextField
            id="input-with-icon-textfield"
            InputProps={{
              style: filterInputStyle,
            }}
            onChange={(e) => onFilterChange(e, ShopperGiftFilter.Id)}
          />
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  type:              PropTypes.oneOf([GiftType.Voucher, GiftType.Coupon]).isRequired,
  numSelected:       PropTypes.number.isRequired,
  onSelectAllClick:  PropTypes.func.isRequired,
  rowCount:          PropTypes.number.isRequired,
  claims:            PropTypes.bool.isRequired,
  filterShopperGift: PropTypes.func.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width:        '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border:   0,
    clip:     'rect(0 0 0 0)',
    height:   1,
    margin:   -1,
    overflow: 'hidden',
    padding:  0,
    position: 'absolute',
    top:      20,
    width:    1,
  },
}));

function Listing(props) {
  const classes = useStyles();
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalToRedeem, setTotalToRedeem] = useState(0);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      let newSelecteds = _.filter(props.data, (d) => {
        if (d.status === RedeemStatus.Redeemed) {
          return d.id;
        }
      });

      newSelecteds = _.map(newSelecteds, (n) => n.id);

      props.setGiftsToClaim(newSelecteds);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
    props.setGiftsToClaim(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, props.data.length - page * rowsPerPage);

  useEffect(() => {
    setSelected([]);

    const toRedeem = _.filter(props.data, (d) => d.status === RedeemStatus.Redeemed);
    setTotalToRedeem(toRedeem.length);
  }, [props.data]);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="medium"
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              type={props.type}
              numSelected={selected.length}
              onSelectAllClick={handleSelectAllClick}
              rowCount={totalToRedeem}
              claims={props.claims}
              filterShopperGift={props.filterShopperGift}
            />

            <TableBody>
              {
                props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row.id);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover
                        onClick={(event) => row.status === RedeemStatus.Redeemed && handleClick(event, row.id)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id}
                        selected={isItemSelected}
                      >
                        {/* <TableCell padding="checkbox">
                          {row.status === RedeemStatus.Redeemed && (
                            <Checkbox
                              checked={isItemSelected}
                              inputProps={{ 'aria-labelledby': labelId }}
                            />
                          )}
                        </TableCell> */}
                        <TableCell>
                          <MText text={row.status} />
                        </TableCell>
                        <TableCell>
                          <MText text={IsEmpty(row.redeemOutletId) ? '-' : row.redeemOutletId} />
                        </TableCell>
                        {/* <TableCell>
                          <MText text={IsEmpty(row.claimDate) ? '-' : row.claimDate} />
                        </TableCell> */}
                        <TableCell>
                          <MText text={IsEmpty(row.issueDate) ? '-' : dateStrToFormat(row.issueDate, 'DD/MM/yyyy')} />
                        </TableCell>

                        <TableCell>
                          <MText text={IsEmpty(row.shopperRedeemDate) ? '-' : dateStrToFormat(row.shopperRedeemDate, 'DD/MM/yyyy')} />
                        </TableCell>
                        {/* <TableCell><MText text={row.issuedBy} /></TableCell> */}
                        <TableCell><MText text={row.id} /></TableCell>
                      </TableRow>
                    );
                  })
              }
              {emptyRows > 0 && (
                <TableRow>
                  <TableCell colSpan={8} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[25, 50, 100]}
          component="div"
          count={props.data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}

Listing.propTypes = {
  data:              PropTypes.arrayOf(PropTypes.shape(Object)).isRequired,
  type:              PropTypes.oneOf([GiftType.Voucher, GiftType.Coupon]).isRequired,
  claims:            PropTypes.bool.isRequired,
  setGiftsToClaim:   PropTypes.func.isRequired,
  filterShopperGift: PropTypes.func.isRequired,
};

export default Listing;
